
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Use the null assertion operator only after checking that the element exists
const rootElement = document.getElementById("root");

if (rootElement) {
  console.log("Root element found, mounting React app");
  const root = createRoot(rootElement);
  root.render(<App />);
} else {
  console.error("Root element not found, cannot mount React app");
}
